/*
创建者 李伟(2018.5.31)
左侧树形菜单
*/
<template>
	<div id="landmarkTree" class="left" v-if="data">
      <div  v-for="(item,index) in treeData" class="landmarkTree-item" v-bind:class="{'active':defaultCollapse==item.id }">
        <span class="landmarkTree-item-name" @click="toggle(item.id)">{{item.name}}<i class="triangle-facing-right"></i></span>
        <ul>
          <li v-for="row in item.regions" :class="{active:row.regionId==regionId}"  @click="changeRegionId(row)" style="display: block"><i class="san_you"></i><span style="vertical-align: middle">{{row.localName}}</span></li>
        </ul>
      </div>
	</div>
</template>
<script>
  import titleBg from '../../assets/images/landmark-product-title.png';
export default {
	props:["data"],
	data(){
		return {
			treeData:this.data,
      regionId:'',
      defaultCollapse:''
		}
	},
  watch:{
    '$route': function () {
      if(this.treeData && this.$route.query.regionId){
        this.regionId = this.$route.query.regionId;
        for(var i in this.treeData){
          for(var o in this.treeData[i].regions){
            if(this.treeData[i].regions[o].regionId == this.regionId){
              this.defaultCollapse = this.treeData[i].regions[o].landRegionsId;
              return;
            }
          }
        }
      }
    }
  },
	created(){
    if(this.treeData && this.$route.query.regionId){
      this.regionId = this.$route.query.regionId;
      for(var i in this.treeData){
        for(var o in this.treeData[i].regions){
          if(this.treeData[i].regions[o].regionId == this.regionId){
            this.defaultCollapse = this.treeData[i].regions[o].landRegionsId;
            return;
          }
        }
      }
    }
	},
	methods:{
    toggle(key){
      this.defaultCollapse = key;
    },
    changeRegionId(item){
			let query = this.$route.query;
			let regionId = item.regionId;
      this.regionId = item.regionId;
      this.defaultCollapse = item.landRegionsId;
			query = {...query,regionId};
			this.$router.push({path:"/landmark-goods-list",query});
		}
	}
}
</script>
<style scoped>
	li{
		margin:3px 0 3px 14px;
	}
.ivu-collapse-item-active{
    background-color: #c62b2f!important;
    color: #ffffff;
  }
#landmarkTree{
  border-top:1px solid #f3f3f3;
    margin-bottom: 20px;
  }

#landmarkTree .landmarkTree-item .landmarkTree-item-name{
  font-size: 14px;
  height: 36px;
  line-height: 36px;
  padding-left: 30px;
  border: 1px solid #f3f3f3;
  margin-top: -1px;
  cursor: pointer;
  display: block;
}
#landmarkTree .landmarkTree-item ul{
    display: none;
    background-color: #fff;
  }
  #landmarkTree div.active{
    background-color: #c62b2f;
  }
  #landmarkTree div.active .landmarkTree-item-name{
    color: #fff;
  }
#landmarkTree div.active ul{
    display: block;
  }
#landmarkTree .landmarkTree-item ul li{
  margin: 0px;;
  padding-left: 30px;
  font-size: 14px;
  height: 36px;
  line-height: 36px;
  cursor: pointer;
  color: #333;
  }
  #landmarkTree .triangle-facing-right {
    display: inline-block;
    float: right;
    margin-right: 15px;
    margin-top: 14px;
    border-right: 2px solid; border-bottom: 2px solid;
    width: 7px; height: 7px;
    transform: rotate(-45deg);
    vertical-align: middle;
    color: #fff;
  }
  .san_you {
    display: inline-block;
    margin-right: 5px;;
    vertical-align: middle;
    display: none;
    height: 0;
    border-top: 7px solid transparent;
    border-left: 8px solid #c62b2f;
    border-bottom: 7px solid transparent;
  }
  #landmarkTree .landmarkTree-item ul li.active .san_you{
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// module-left-tree.vue?75b10c1e